import { PaginationModel } from './util.models';

export class full_message_sent {
    patient_guid?: string;
    user_guid?: string;
    p_accounts?: {
        first_name: string;
        middle_name: string;
        last_name: string;
    };
    egd_users?: {
        first_name: string;
        middle_name: string;
        last_name: string;
    };
    messages: {
        subject: string;
        message: string;
        has_attachment: boolean;
        attachment_src: string[];
        reply_id: number;
        created_at: Date;
        user_guid?: string;
        patient_guid?: string;
        flagged: boolean;
        id: number;
    };
}

export class full_message {
    user_guid?: string;
    patient_guid?: string;
    flagged: boolean;
    read?: boolean;
    messages: {
        subject: string;
        message: string;
        has_attachment: boolean;
        attachment_src: string[];
        reply_id: number;
        created_at: Date;
        patient_guid?: string;
        user_guid?: string;
        id: number;
        p_accounts?: {
            first_name: string;
            middle_name: string;
            last_name: string;
        };
        egd_users?: {
            first_name: string;
            middle_name: string;
            last_name: string;
        };
    };
}

export class common_message {
    id?: number;
    from?: string;
    to?: string;
    subject?: string;
    message?: string;
    date?: Date;
    flagged?: boolean;
    selected?: boolean;
    read?: boolean;
    message_id?: number;
    patient_guid?: string;
    user_guid?: string;
}

export class GetAllQuery {
    user_guid?: string;
    patient_guid?: string;
    sent: boolean;
    flagged?: boolean;
    page_no: number;
    messages_per_page: number;
}

export class GetMessageQuery {
    user_guid?: string;
    patient_guid?: string;
    message_id: number;
    sent: boolean;
}

export class GetNewQuery {
    patient_guid?: string;
    user_guid?: string;
    total_messages: number;
    sent: boolean;
}

export class NewMessage {
    from_user_guid?: string;
    to_user_guid?: string[];
    user_guid?: string;
    patient_guid?: string;
    subject: string;
    message: string;
    reply_id: number;
}

export class UpdateMessage {
    sent: boolean;
    read_value?: boolean;
    flagged?: boolean;
    message_id: number[];
}

export class DeleteMessage {
    message_id: number[];
    page_no: number;
    messages_per_page: number;
}


export enum message_state {
    all = 'all',
    read = 'read',
    unread = 'unread',
    flagged = 'flagged'
}

export class DoctorList {
    first_name: string;
    middle_name: string;
    last_name: string;
    user_guid: string;
    doctor_profile?: {
        user_guid?: string;
        p_consultation?: any[];
        speciality?: {
            specialty_name?: string;
        };
    };
    country?: {
        country_name?: string;
    };
}

export class MyPatients {
    first_name: string;
    middle_name: string;
    last_name: string;
    patient_guid: string;
}

export class PatientProfileQuery extends PaginationModel {
    patient_guid: string;
    sent: boolean;
}
